/* eslint-disable consistent-return */
import { ApiResponse } from '../@types';
import { request } from '../../utils';

export interface ClassroomData {
  classroom_name: string;
  classroom_id: string;
  creator_id: string;
  creator_email?: string;
  archived?: boolean;
}

export interface teacherStudentConnection {
  teacher_id: string;
  student_id: string;
}

export interface collaborator {
  classroom_id: string;
  email: string;
}

export interface ClassCodeData {
  class_code: string | null;
  email: string | null;
}

export const getClassrooms = async (
  creatorId: string,
  archive: boolean,
): Promise<ApiResponse<any>> => {
  return request<ApiResponse<any>>({
    url: `classrooms/${creatorId}&${archive}`,
    method: 'GET',
  });
};

export const getAllClassrooms = async (): Promise<ApiResponse<any>> => {
  return request<ApiResponse<any>>({
    url: `classrooms/all`,
    method: 'GET',
  });
};

export const getStudentClassrooms = async (userId: string): Promise<ApiResponse<any>> => {
  return request<ApiResponse<any>>({
    url: `classrooms/student-${userId}`,
    method: 'GET',
  });
};
export const getClassroom = async (
  classroomId: string | string[],
  queryType: string | string[],
): Promise<ApiResponse<any>> => {
  return request<ApiResponse<any>>({
    url: `classrooms/get/${classroomId}/${queryType}`,
    method: 'GET',
  });
};

export const getClassroomWithCode = async (code: string | string[]): Promise<ApiResponse<any>> => {
  return request<ApiResponse<any>>({
    url: `classrooms/get/${code}`,
    method: 'GET',
  });
};

export const getStudentsForTeacher = async (teacherId: string): Promise<ApiResponse<any>> => {
  return request<ApiResponse<any>>({
    url: `classrooms/teacher-students/${teacherId}`,
    method: 'GET',
  });
};

export const createClassroom = async (
  credential: Partial<ClassroomData>,
): Promise<ApiResponse<void>> => {
  return request<ApiResponse<void>>({
    url: 'classrooms/create',
    method: 'POST',
    data: credential,
  });
};

export const joinClassroom = async (
  credential: Partial<ClassCodeData>,
): Promise<ApiResponse<void>> => {
  return request<ApiResponse<void>>({
    url: 'classrooms/join',
    method: 'POST',
    data: credential,
  });
};

export const inviteCollaborator = async (
  credential: Partial<collaborator>,
): Promise<ApiResponse<void>> => {
  return request<ApiResponse<void>>({
    url: 'classrooms/invite_collaborator',
    method: 'POST',
    data: credential,
  });
};

export const getStudent = async (
  credential: Partial<teacherStudentConnection>,
): Promise<ApiResponse<any>> => {
  return request<ApiResponse<any>>({
    url: `classrooms/student`,
    method: 'POST',
    data: credential,
  });
};

export const archiveClassroom = async (
  credential: Partial<ClassroomData>,
): Promise<ApiResponse<void>> => {
  return request<ApiResponse<void>>({
    url: 'classrooms/archive_classroom',
    method: 'POST',
    data: credential,
  });
};
export const renameClassroom = async (
  credential: Partial<ClassroomData>,
): Promise<ApiResponse<void>> => {
  return request<ApiResponse<void>>({
    url: 'classrooms/rename_classroom',
    method: 'POST',
    data: credential,
  });
};

export const resetCode = async (credential: Partial<ClassroomData>): Promise<ApiResponse<void>> => {
  return request<ApiResponse<void>>({
    url: 'classrooms/reset_code',
    method: 'POST',
    data: credential,
  });
};

export const deleteClassroom = async (
  credential: Partial<ClassroomData>,
): Promise<ApiResponse<void>> => {
  return request<ApiResponse<void>>({
    url: 'classrooms',
    method: 'DELETE',
    data: credential,
  });
};

export const removeStudent = async (
  credential: Partial<teacherStudentConnection>,
): Promise<ApiResponse<void>> => {
  return request<ApiResponse<void>>({
    url: 'classrooms/remove_student',
    method: 'DELETE',
    data: credential,
  });
};
